import * as React from "react";
type Props = {
  className?: string,
};
function SvgThumbsUp({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-thumbs-up"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 9.39999C8.55228 9.39999 9 9.8477 9 10.4V20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20V10.4C7 9.8477 7.44772 9.39999 8 9.39999Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1058 3.55227C11.2773 3.20978 11.6294 2.99533 12.0124 3.00008C12.5403 3.00661 13.0599 3.13237 13.5324 3.36794C14.0049 3.60351 14.4181 3.9428 14.741 4.36048C15.064 4.77816 15.2884 5.26341 15.3974 5.77999C15.5063 6.29591 15.4974 6.82974 15.3713 7.34172L15.3708 7.34369L14.8718 9.4H18.264C18.6676 9.4 19.0657 9.49397 19.4268 9.67449C19.7878 9.855 20.1018 10.1171 20.344 10.44C20.5862 10.7629 20.7499 11.1378 20.8221 11.5349C20.8942 11.9319 20.873 12.3402 20.7601 12.7276L18.8961 19.1276C18.7386 19.6677 18.4101 20.1425 17.96 20.48C17.5099 20.8175 16.9626 21 16.4 21H5.6C4.91044 21 4.24912 20.7261 3.76152 20.2385C3.27393 19.7509 3 19.0896 3 18.4V12C3 11.3104 3.27393 10.6491 3.76152 10.1615C4.24912 9.67392 4.91044 9.4 5.6 9.4H7.80747C7.91909 9.39994 8.02849 9.36874 8.12336 9.30991C8.21822 9.25108 8.2948 9.16696 8.34447 9.067L8.34583 9.06426L11.1058 3.55227ZM12.5576 5.11979L10.1355 9.957L10.1348 9.95849C9.91952 10.391 9.58799 10.755 9.17737 11.0096C8.76629 11.2646 8.29224 11.3997 7.80853 11.4H5.6C5.44087 11.4 5.28826 11.4632 5.17574 11.5757C5.06321 11.6883 5 11.8409 5 12V18.4C5 18.5591 5.06321 18.7117 5.17574 18.8243C5.28826 18.9368 5.44087 19 5.6 19H16.4C16.5298 19 16.6561 18.9579 16.76 18.88C16.8638 18.8022 16.9395 18.6928 16.9759 18.5684M16.9759 18.5684L18.8399 12.1684C18.866 12.0789 18.871 11.9843 18.8543 11.8927C18.8377 11.801 18.7999 11.7145 18.744 11.64C18.6881 11.5655 18.6156 11.505 18.5323 11.4633C18.449 11.4217 18.3571 11.4 18.264 11.4H13.6C13.2933 11.4 13.0035 11.2592 12.8139 11.0181C12.6243 10.777 12.5559 10.4622 12.6282 10.1641L13.4282 6.86813L13.4292 6.86431C13.4835 6.6443 13.4874 6.41486 13.4406 6.19313C13.3937 5.9714 13.2974 5.76312 13.1588 5.58384C13.0202 5.40457 12.8429 5.25893 12.6401 5.15782C12.6129 5.1443 12.5855 5.13162 12.5576 5.11979"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgThumbsUp;
